import inicialState from './cish.state';
import * as actions from './cish.action';

const cishReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.CISH_FINALIZADA:
      return {
        ...state,
        cishFinalizada: action.payload.cishFinalizada,
      };
    default:
      return state;
  }
};

export default cishReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/cish/cish.reducer.js